import { useTranslation } from 'react-i18next';
import { Progress } from '@parrot-software/design-system';

type WizardProgressProps = {
  currentStep: number;
  totalSteps: number;
};

/**
 * Desktop-only progress block — lives inside the Card.
 * Renders step label + full-width progress bar.
 * Hidden below the `lg` breakpoint (mobile/tablet use WizardHeader instead).
 */
export const WizardProgress = ({ currentStep, totalSteps }: WizardProgressProps) => {
  const { t } = useTranslation('onboarding');
  const progressPercentage = ((currentStep + 1) / totalSteps) * 100;

  return (
    <div className="hidden w-full flex-col gap-2 lg:flex">
      <p className="text-xs font-medium leading-3 text-muted-foreground">
        {t('wizard.progress', { current: currentStep + 1, total: totalSteps })}
      </p>
      <Progress className="h-1 [&>div]:bg-primary" value={progressPercentage} />
    </div>
  );
};
